import {
  TableHead as MUITableHead,
  TableBody as MUITableBody,
  Button,
  styled,
  alpha,
  darken,
  lighten,
} from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { SubscriptionType } from "types/enums";
import { getColorByMode } from "utils";

export const TableBody = styled(MUITableBody)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    "& tr td": {
      fontSize: { sm: "0.875rem", xs: "0.75rem" },
      fontWeight: fontWeight.light,
      color: getColorByMode(theme, colors.deepMidnightBlue, colors.gray800),
    },
    "& > tr td:first-of-type": {
      fontSize: { sm: "1rem", xs: "0.875rem" },
      fontWeight: fontWeight.medium,
      color: getColorByMode(theme, colors.deepMidnightBlue, colors.gray800),
    },
    "& > tr td": {
      border: 0,
    },
    "& > tr:nth-of-type(odd)": {
      backgroundColor: alpha(colors.gray450, 0.05),
    },
  };
});

export const TableHead = styled(MUITableHead)(() => ({
  "& > tr th": {
    border: 0,
  },
}));

export const SubscriptionButton = styled(Button)<{ subscriptiontype?: SubscriptionType }>(
  ({ theme, subscriptiontype }) => {
    const { colors } = useMUIThemeModeContext();
    let backgroundColor = colors.dustyMint;
    let hoverColor = getColorByMode(theme, darken(backgroundColor, 0.1), lighten(backgroundColor, 0.15));

    if (subscriptiontype === SubscriptionType.PREMIUM) {
      backgroundColor = colors.purple400;
      hoverColor = getColorByMode(theme, darken(backgroundColor, 0.15), lighten(backgroundColor, 0.15));
    } else if (subscriptiontype === SubscriptionType.PRO) {
      backgroundColor = getColorByMode(theme, colors.deepMidnightBlue, colors.gray800);
      hoverColor = getColorByMode(theme, lighten(backgroundColor, 0.15), darken(backgroundColor, 0.15));
    }

    return {
      borderRadius: "12px",
      fontSize: "0.9375rem",
      backgroundColor: backgroundColor,
      color: colors.white,

      "&:hover": {
        backgroundColor: hoverColor,
      },

      "&:disabled": {
        backgroundColor: colors.gray200,
        color: getColorByMode(theme, colors.deepMidnightBlue, colors.gray800),
      },
    };
  }
);
